var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records.length
            ? [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-0" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.sortArray(_vm.records, "title"),
                        function (r, i) {
                          return _c("tr", { key: r.id }, [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("p", [
                                _vm._v(
                                  "(" + _vm._s(r.id) + ") " + _vm._s(r.title)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("i", [
                                  _vm._v(
                                    _vm._s(r.user?.short_name ?? r.user?.name)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              r.status === 2
                                ? _c("p", [
                                    _c(
                                      "span",
                                      { staticClass: "badge badge-info" },
                                      [_vm._v("кредит")]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              _vm._l(r.cities, function (c) {
                                return _c("p", [_vm._v(_vm._s(c.city?.name))])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(r.stores?.[0]?.store?.title)),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", { staticClass: "input-group" }, [
                                _vm._m(1, true),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.settings.mapCenter[0],
                                      expression: "r.settings.mapCenter[0]",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: r.settings.mapCenter[0] },
                                  on: {
                                    change: () => (r.to_update = true),
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        r.settings.mapCenter,
                                        0,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _vm._m(2, true),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.settings.mapCenter[1],
                                      expression: "r.settings.mapCenter[1]",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: r.settings.mapCenter[1] },
                                  on: {
                                    change: () => (r.to_update = true),
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        r.settings.mapCenter,
                                        1,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default btn-xs",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addNewZone(r)
                                      },
                                    },
                                  },
                                  [_vm._v("добавить зону")]
                                ),
                                _vm._v(" "),
                                _vm._l(r.settings.mapAreas ?? [], function (a) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-1 pb-1 border-bottom" },
                                    [
                                      _c("MapArea", {
                                        attrs: {
                                          area: a,
                                          toUpdate: () => (r.to_update = true),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.settings.cashOutType,
                                      expression: "r.settings.cashOutType",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          r.settings,
                                          "cashOutType",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      () => (r.to_update = true),
                                    ],
                                  },
                                },
                                _vm._l(
                                  _vm.$platformConstants.cashOutTypes,
                                  function (o, type) {
                                    return _c(
                                      "option",
                                      { domProps: { value: type } },
                                      [_vm._v(_vm._s(o.title))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td"),
                          ])
                        }
                      ),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-1 text-right" },
                  [
                    _c("LoadingButton", {
                      staticClass: "btn btn-success",
                      attrs: {
                        title: "Сохранить",
                        loading: _vm.btnLoading,
                        type: "button",
                        color: "white",
                        onClick: () => _vm.updateRecords(),
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дивизион")]),
        _vm._v(" "),
        _c("th", [_vm._v("Города")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "175px" } }, [_vm._v("центр карты")]),
        _vm._v(" "),
        _c("th", [_vm._v("зоны на карте")]),
        _vm._v(" "),
        _c("th", [_vm._v("инкассация")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text small" }, [_vm._v("Lat")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text small" }, [_vm._v("Lon")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }